<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1>About the Author</h1>
<p>Tom B. Stone grew up in a funeral home in the Mountain West. After spending 2 years abroad in Argentina, he decided the funeral business wasn’t for him and chose a career in medicine instead. Now he has the honor to care for some of our nation’s veterans who continue to serve him as educators and inspiration for his stories. He currently lives in the Midwest with his wife, 5 children, and 10,000 honeybees.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?9f709272